import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4,
    _t5;

import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import styled from 'styled-components';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import { H4 } from 'UIComponents/elements/headings';
import BringCommerceCTAs from './BringCommerceCTAs';
import { BringCommerceFeatureHighlights } from './BringCommerceFeatureHighlights';
const StyledCardWrapper = styled(UICardWrapper).withConfig({
  displayName: "BringCommerceCtaCard__StyledCardWrapper",
  componentId: "sc-70g5en-0"
})(["display:grid;grid-template-columns:1fr 1fr;grid-column-gap:100px;width:100%;padding:40px 40px 8px;box-shadow:0 1px 5px 0 #2d3e501f;min-height:150px;text-align:left;margin:auto;margin-top:20px;position:relative;overflow:hidden;", ";", ";"], breakpoint.tablet(_t || (_t = _`
    min-width: 0;
    &&& {
      margin: 0 auto;
    }

    padding 12px;

    grid-template-columns: 1fr;
  `)), breakpoint.tabletPortrait(_t2 || (_t2 = _`
    width: 94%;
  `)));
const ContentContainer = styled.div.withConfig({
  displayName: "BringCommerceCtaCard__ContentContainer",
  componentId: "sc-70g5en-1"
})(["display:flex;flex-direction:column;", ""], breakpoint.phoneLarge(_t3 || (_t3 = _`
    margin-top: 32px;
  `)));
const CTAsContainer = styled.div.withConfig({
  displayName: "BringCommerceCtaCard__CTAsContainer",
  componentId: "sc-70g5en-2"
})(["margin-top:35px;max-width:350px;width:100%;button,a{width:100%;line-height:25px;}", ""], breakpoint.tablet(_t4 || (_t4 = _`
    max-width: 100%;
  `)));
const FeaturesContainer = styled.div.withConfig({
  displayName: "BringCommerceCtaCard__FeaturesContainer",
  componentId: "sc-70g5en-3"
})(["display:flex;flex-direction:column;justify-content:space-between;", ""], breakpoint.tablet(_t5 || (_t5 = _`
    margin-top: 50px;
  `)));
const StyledTitle = styled(H4).withConfig({
  displayName: "BringCommerceCtaCard__StyledTitle",
  componentId: "sc-70g5en-4"
})(["color:#33475b;"]);

const BringCommerceCtaCard = () => {
  return /*#__PURE__*/_jsxs(StyledCardWrapper, {
    children: [/*#__PURE__*/_jsxs(ContentContainer, {
      children: [/*#__PURE__*/_jsx(StyledTitle, {
        "aria-level": 2,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.commerce.card.title"
        })
      }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "pricingPage.pages.commerce.card.description_jsx",
        elements: {
          br: () => /*#__PURE__*/_jsx("br", {})
        }
      }), /*#__PURE__*/_jsx(CTAsContainer, {
        children: /*#__PURE__*/_jsx(BringCommerceCTAs, {})
      })]
    }), /*#__PURE__*/_jsx(FeaturesContainer, {
      children: /*#__PURE__*/_jsx(BringCommerceFeatureHighlights, {})
    })]
  });
};

export default BringCommerceCtaCard;